import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('mg_token') || '');
  const [member, setMember] = useState(null);
  const [claimedProfile, setClaimedProfile] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(localStorage.getItem('mg_role') || '');

  const authHeaders = useCallback(() => ({
    headers: { Authorization: `Bearer ${token}` }
  }), [token]);

  const logout = useCallback(() => {
    setToken('');
    setMember(null);
    setAdmin(null);
    setClaimedProfile(null);
    setRole('');
    localStorage.removeItem('mg_token');
    localStorage.removeItem('mg_role');
    localStorage.removeItem('mg_admin');
  }, []);

  useEffect(() => {
    const init = async () => {
      if (!token) { setLoading(false); return; }
      try {
        if (role === 'member') {
          const res = await axios.get(`${API}/members/profile`, authHeaders());
          setMember(res.data.account);
          setClaimedProfile(res.data.claimed_profile);
        } else if (role === 'admin') {
          setAdmin(JSON.parse(localStorage.getItem('mg_admin') || '{}'));
        }
      } catch (err) {
        console.error('[AuthContext] init failed, logging out:', err);
        logout();
      }
      setLoading(false);
    };
    init();
  }, [token, role, authHeaders, logout]);

  const loginMember = useCallback((t, m) => {
    setToken(t);
    setMember(m);
    setRole('member');
    localStorage.setItem('mg_token', t);
    localStorage.setItem('mg_role', 'member');
  }, []);

  const loginAdmin = useCallback((t, a) => {
    setToken(t);
    setAdmin(a);
    setRole('admin');
    localStorage.setItem('mg_token', t);
    localStorage.setItem('mg_role', 'admin');
    localStorage.setItem('mg_admin', JSON.stringify(a));
  }, []);

  const updateMember = useCallback((m) => setMember(m), []);
  const updateClaimedProfile = useCallback((p) => setClaimedProfile(p), []);

  return (
    <AuthContext.Provider value={{ token, member, claimedProfile, admin, role, loading, loginMember, loginAdmin, logout, updateMember, updateClaimedProfile, authHeaders, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
